export { default as fixFlipCover } from './fix-flip-cover.png';
export { default as groundUpCover } from './ground-up-cover.png';
export { default as stabilizedBridgeCover } from './stabilized-bridge-cover-2.png';
export { default as singlePropertyCover } from './single-property-cover.png';
export { default as rentalPortfolioCover } from './rental-portfolio-cover-2.png';
export { default as multifamilyBridgeCover } from './multifamily-bridge.jpg';
